import {SocialVendor} from '../../constants';
import {IMediaItem, IProductDTO} from '../../types/app-types';
import {defaultProductMediaImage} from '@wix/wixstores-client-core/dist/es/src/builders/product/mediaItems.builder';
import {ShouldRenderVarsKeys} from '../../../components/ProductPage/customCssVars/shouldRenderVars';

export function getDefaultProductMedia(product: IProductDTO): IMediaItem {
  return /* istanbul ignore next: todo: test */ product.media && product.media.length > 0
    ? product.media[0]
    : defaultProductMediaImage;
}

const SocialVendorStyleParam = {
  [SocialVendor.Facebook]: 'productPage_socialNetworkfacebook',
  [SocialVendor.Pinterest]: 'productPage_socialNetworkpinterest',
  [SocialVendor.WhatsApp]: 'productPage_socialNetworkwhatsapp',
  [SocialVendor.Twitter]: 'productPage_socialNetworktwitter',
};

export const getVenderStyleParam = (vendor: SocialVendor): Partial<ShouldRenderVarsKeys> => {
  return SocialVendorStyleParam[vendor];
};
